// src/components/menuIconMap.js
import {
    FaTachometerAlt,
    FaRegFileAlt,
    FaUsersCog,
    FaUserCog,
    FaCogs,
    FaBuilding,
    FaBook,
    FaCalendarAlt,
    FaClipboardCheck,
    FaBed,
    FaListUl,
    FaTools,
    FaDoorOpen,
    FaCalendar,
    FaBroom,
    FaWrench,
    FaFileAlt,
    FaUsers,
    FaUserFriends,
    FaFileInvoice,
    FaClipboardList,
    FaMoneyBillWave,
    FaPercentage,
    FaGift,
    FaLayerGroup,
    FaImage,
    FaTags,
    FaHotel,
    FaDollarSign,  // New icon for PricePage
    FaUtensils,    // New icon for RestaurantOrderPage
    FaConciergeBell, // New icon for CreateServicePage
    FaCss3,
    FaKey ,
    FaLifeRing,
    FaHeadset,     
     FaGavel,   

  } from 'react-icons/fa';
 
  const menuIconMap = {
    "SystemLogPage": FaClipboardList,   // ← new page → clip-board-list icon
    // Content / Info Pages
    "AboutUsPage": FaBuilding,
    "FeaturesPage": FaCalendarAlt,
    "PricingPage": FaClipboardCheck,
    "ContactUsPage": FaTools,
    "CssEditorPage": FaCss3,
    // Landing & Auth Pages
    "LandingPage": FaTachometerAlt,
    "Login": FaUserCog,
    "Registration": FaUserFriends,
    "ResetPassword": FaCogs,
    "ForgotPassword": FaCogs,
    "Unauthorized": FaFileAlt,
    "EmailConfirmation": FaImage,
    "ResendConfirmationPage": FaImage,
    "EmailConfirmationPendingPage": FaFileInvoice,
  
    // Support
    "SupportPage": FaLifeRing,
    "SupportAdminPage": FaHeadset, // or FaTools if you prefer

    //Dashboard & Settings
    "Dashboard": FaTachometerAlt,
    "AdminDashboard": FaTachometerAlt,
    "Settings": FaCogs,
    "SettingsPage": FaCogs,
    "ProfileSettingsPage": FaUserCog,
    "AccountSettingsPage": FaCogs,
  
    // Hotel & Booking Pages
    "HotelProfilePage": FaBuilding,
    "BookingListPage": FaBook,
    "BookingPage": FaBook,
    // "BookingDetailPage": FaRegFileAlt, // Uncomment if available
    "CheckInOutPage": FaClipboardCheck,
    "CheckOut": FaClipboardCheck,
    "ReservationCalendarPage": FaCalendar,
    "ReservationGantt": FaCalendar,
    "RoomListPage": FaBed,
    "RoomStatusPage": FaListUl,
    "RoomMaintenancePage": FaWrench,
    "AmenitiesPage": FaDoorOpen,
    "AmenitiesListPage": FaFileAlt,
    "ActivitiesListPage": FaUserFriends,
    "EventsPage": FaCalendarAlt,
    "EventsListPage": FaCalendarAlt,
    "TasksPage": FaClipboardList,
    "MaintenanceRequestsPage": FaWrench,
    "ReportsPage": FaFileInvoice,
    "GuestListPage": FaUsers,
    "GuestProfilesPage": FaUsersCog,
    "ReservationReportsPage": FaFileInvoice,
    "HousekeepingPage": FaClipboardList,
    "HousekeepingReportsPage": FaClipboardList,
  
    "GuestBillingPage": FaFileInvoice,

    // Financial & Other Pages
    "FinancialReport": FaMoneyBillWave,
    "BedTypesPage": FaBed,
    "BookingTypesPage": FaUserCog,
    "RatesPage": FaPercentage,
    // New entry for GetRoomTypes
    "RoomTypesPage": FaTags,
    "HousekeeperDashboard": FaTachometerAlt,
    "FloorPlansPage": FaLayerGroup,
    "RoomImagesPage": FaImage,
    "PromotionsPage": FaGift,
    "ManageStaffPage": FaUsersCog,
    "AddStaffPage": FaUserFriends,
  
    // Additional / Utility Pages
    "ModuleAssignment": FaTools,
    "RoomQRPage": FaClipboardCheck,
    "ManageUsers": FaUsers,
    "FacilitiesPage": FaBuilding,
    "AddUserPage": FaUserFriends,
    "KYCVerificationPage": FaFileAlt,
    "SetupHotelPage": FaCogs,
    "KYCUploadPage": FaFileAlt,
    "KycReviewPage": FaFileAlt,
    "HotelForm": FaHotel,
     // New mapping for the Price module
    "RoomPricePage": FaDollarSign,

    "MaintenanceDashboard": FaTachometerAlt,    // Use a dashboard icon
    "MaintenancePage": FaWrench,               // Use a wrench icon
    "MaintenanceRequestForm": FaFileAlt,         // Generic file icon (change if desired)

     // New mappings for additional modules
  "RestaurantOrderPage": FaUtensils,
  "CreateServicePage": FaConciergeBell,
      "PermissionManager": FaKey,  // Added PermissionManager with key icon
"HotelSettings": FaCogs,
"AdminLegalDocsPage": FaGavel,
  };
  
  export default menuIconMap;
  